import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { departmentDashboard } from '../../actions/constant';
import departmentDashboardService from '../../../services/departmentDashboard/getDepartmentDashboardCount';
const {
  CHECK_ASSIGN_TASK_PTO_REQUEST,
  CHECK_ASSIGN_TASK_PTO_SUCCESS,
  CHECK_ASSIGN_TASK_PTO_FAILURE,
  CHECK_ASSIGN_TASK_PTO_LOADING,
  CHECK_ASSIGN_TASK_PTO_RESET,
} = departmentDashboard;

function* checkAssignTaskPTO(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: CHECK_ASSIGN_TASK_PTO_LOADING });
    const response = yield call(departmentDashboardService.checkTaskPTO, payload);
    if (response?.status === 200) {
      yield put({ type: CHECK_ASSIGN_TASK_PTO_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: CHECK_ASSIGN_TASK_PTO_FAILURE, payload: error });
  }
}

function* checkAssignTaskPTOSaga() {
  yield takeEvery(CHECK_ASSIGN_TASK_PTO_REQUEST, checkAssignTaskPTO);
}

export default checkAssignTaskPTOSaga;
